package one.healthium.pilates.di

import one.healthium.data.common.serializer.ColorThemeProvider
import one.healthium.domain.paywall.PaywallIdProvider
import one.healthium.pilates.AppLaunchViewModel
import one.healthium.pilates.IfaColorThemeProvider
import one.healthium.pilates.appConfig
import one.healthium.pilates.presentation.navigation.main.MainViewModel
import one.healthium.pilates.providers.AppIconsProvider
import one.healthium.pilates.providers.AppPaywallIdProvider
import one.healthium.pilates.providers.AppResourceProvider
import one.healthium.pilates.ui.workouts.WorkoutsViewModel
import one.healthium.ui.compose.components.IconsProvider
import one.primehealth.app.BaseAppConfig
import one.primehealth.app.BaseAppResourceProvider
import org.koin.core.module.dsl.factoryOf
import org.koin.core.module.dsl.singleOf
import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.bind
import org.koin.dsl.module

val composeModule = module {
    includes(composeAppPlatformModule())

    singleOf(::AppResourceProvider) bind BaseAppResourceProvider::class
    singleOf(::AppPaywallIdProvider) bind PaywallIdProvider::class
    singleOf(::AppIconsProvider) bind IconsProvider::class

    factory { appConfig(get()) }
    factory { get<BaseAppConfig>().baseUrls }

    factoryOf(::IfaColorThemeProvider) bind ColorThemeProvider::class

    viewModelOf(::AppLaunchViewModel)
    viewModelOf(::WorkoutsViewModel)
    viewModelOf(::MainViewModel)
}
